import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function DashboardIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path d="M0 0h24v24H0z" fill="none" />
      <Path
        d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
        fill={color}
      />
    </Svg>
  );
}

export default DashboardIcon;
